import React from 'react';
import { ClipboardListIcon, BarChart3Icon, CalendarIcon, HomeIcon, QrCodeIcon, ShareIcon } from 'lucide-react';
const HowItWorks = () => {
  const steps = [{
    icon: <ClipboardListIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-103" />,
    title: 'Elige el plan que más te conviene',
    description: 'Desde la app puedes seleccionar el plan que mejor se ajusta a tu consumo mensual.'
  }, {
    icon: <BarChart3Icon size={48} className="text-[#2d98e2] mb-4" data-id="element-104" />,
    title: 'Visualiza tu consumo diario',
    description: 'Lleva un control claro y fácil de cuánta agua estás utilizando.'
  }, {
    icon: <CalendarIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-105" />,
    title: 'Programa tus recargas desde la app',
    description: 'Decide cuándo y cuánta agua necesitas. Nosotros nos encargamos del resto.'
  }, {
    icon: <HomeIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-106" />,
    title: 'Recibe tu agua en casa, siempre fresca',
    description: 'Nuestro Agente de Bienestar llega hasta tu puerta para limpiar, llenar y sellar tus garrafones en el momento.'
  }, {
    icon: <QrCodeIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-107" />,
    title: 'Accede a nuestra red de máquinas expendedoras',
    description: 'Como suscriptor, puedes utilizar cualquier expendedora Guaterflow escaneando tu QR desde la app.'
  }, {
    icon: <ShareIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-108" />,
    title: '¡Comparte agua, comparte vida!',
    description: 'Con tu QR Solidario puedes transferir agua a quienes más la necesitan.'
  }];
  return <section id="como-funciona" className="py-16 bg-white" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="text-center mb-16" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-112">
            ¿Cómo funciona Guaterflow?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-113">
            Un proceso simple y eficiente para que siempre tengas agua
            purificada
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-114">
          {steps.map((step, index) => <div key={index} className="bg-blue-50 p-6 rounded-xl text-center hover:shadow-lg transition-shadow relative" data-id="element-115">
              {index < steps.length - 1 && <div className="hidden lg:block absolute -right-4 top-1/2 transform -translate-y-1/2 z-10 text-[#2d98e2]" data-id="element-116">
                  →
                </div>}
              <div className="flex justify-center" data-id="element-117">{step.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-118">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-119">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default HowItWorks;